import { Component, DestroyRef, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { HtmlNode, NavigationService } from '@frontend/vanilla/core';
import { TrustAsResourceUrlPipe } from '@frontend/vanilla/shared/browser';

import { LoginIntegrationConfig } from '../integration/login-integration.client-config';

@Component({
    imports: [TrustAsResourceUrlPipe],
    selector: 'lh-danske-spil-login-option',
    templateUrl: 'danske-spil-login-option.html',
})
export class DanskeSpilLoginOptionComponent implements OnInit, OnDestroy {
    private config = inject(LoginIntegrationConfig);
    private htmlNode = inject(HtmlNode);
    private navigationService = inject(NavigationService);
    private destroyRef = inject(DestroyRef);

    url: string;

    ngOnInit(): void {
        this.config.whenReady.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.url = this.config.options.loginUrl + this.getLoginSuccessPage();
            this.htmlNode.setCssClass('danske-spil-login', true);
        });
    }

    ngOnDestroy(): void {
        this.htmlNode.setCssClass('danske-spil-login', false);
    }

    private getLoginSuccessPage(): string {
        return encodeURIComponent(
            `${this.navigationService.location.baseUrl()}/${this.navigationService.location.culture}/labelhost/danske-spil-login-success`,
        );
    }
}
